<template>
    <div>

        <rkm-alert show info>
            <strong>Data:</strong> {{ data }} -
            <strong>Município: </strong>{{ municipio.nome }}
        </rkm-alert>

        <div
            v-for="(destino, index) in items.destinos"
            class="mb-3"
            :key="index"
        >
            <rkm-table
                :fields="fields"
                :items="destino.agendados"
                ref="Table"
                hide-filters
                sort-by="horarioSaida"
            >

                <template #thead-top>
                    <rkm-tr>
                        <rkm-th class="col-max text-center" colspan="2">
                            {{ destino.destino }}
                        </rkm-th>
                    </rkm-tr>
                </template>

                <template v-slot:custom-foot>
                    <tr>
                        <th>
                            Total
                        </th>
                        <th>
                            {{ destino.quantidade }}
                        </th>
                    </tr>
                </template>
            </rkm-table>
        </div>

        <div class="row" v-if="total">
            <div class="total">Total</div>
            <div>{{ total }}</div>
        </div>

        <rkm-table
            v-if="items.destinos && items.destinos.length === 0"
            :fields="fields"
            :items="items.destinos"
            ref="Table"
            hide-filters
        />

    </div>
</template>

<script>

// Moment.
import moment from 'moment'

// Mixins.
import { error, repository, stringCase, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {

            const fields = [
                {
                    key: 'horarioSaida',
                    label: 'Horário saída',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'quantidade',
                    label: 'Passageiros',
                    class: 'col-max',
                    sortable: true
                },
            ]

            return fields
        },
    },
    created() {

        this.repositories.agendar = this.getConectaSusRepository('transportePaciente.agendar')

        this.load()
    },
    data: () => ({
        repositories: {
            agendar: null,
        },
        items: [],
        data: null,
        total: null,
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        convertBooleanToBinary: (valor) => valor ? 1 : 0,
        trataNull: (valor) => valor === undefined || valor == null ? null : valor,
        load() {

            if (this.consultaData) {

                this.setLoading()

                this.data = moment(this.consultaData).format('DD/MM/YYYY')

                this.repositories.agendar.getAgendados({
                    municipio_id: this.municipio.id,
                    data: moment(this.consultaData).format('YYYY-MM-DD')
                })
                    .then(({ data }) => {

                        this.items = data
                        this.total = data.municipio.total
                    } )
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
    },
    mixins: [ error, repository, stringCase, object ],
    props: {
        consultaData: { type: [Date], default: null },
        municipio: { type: [Object], default: null }
    },
}
</script>

<style scoped>
.row {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border: 1px solid #dee2e6;
    margin: 0;
}
.total {float:left; width: 54%}
</style>